import * as Preact from "preact"
import Resize from "@fae/source/engine/Resize.js"
import Pointer from "poin"

import "./Frame.less"

export default class Frame {
    render() {
        return (
            <div class="Frame" key="frame" id="frame" onContextMenu={this.onContextMenu}>
                {this.props.children}
            </div>
        )
    }
    componentDidMount() {
        Resize({
            "width": 16,
            "height": 9,
            "domId": "frame"
        })
    }
    componentDidUpdate() {
        Resize()
    }
    onContextMenu(event) {
        event.preventDefault()
    }
}
